import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { LIST_ERPS_INIT, CREATE_ERP_INIT, UPDATE_ERP_INIT, DELETE_ERP_INIT, ADD_ERP_VERSAO_INIT } from '../actionTypes';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { listErpsSuccess, createErpSuccess, updateErpSuccess, deleteErpSuccess, addErpVersaoSuccess, requestErrorErps } from './actions';
import { listarErps, criarErp, atualizarErp, removerErp, adicionarVersaoErp } from 'src/integracoes/servicos/mongo-atlas/funcoes/erps';

// --------------------------- List ERPs ---------------------------------------------------------
const fetchListarErps = async () => {
  try {
    const { status, dados, mensagem } = await listarErps();
    if (status && Array.isArray(dados)) {
      return { isError: false, erps: dados, errorMessage: null };
    }
    return { isError: true, erps: [], errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarErps() {
  try {
    const { isError, erps, errorMessage } = yield call(fetchListarErps);
    if (!isError) {
      yield put(listErpsSuccess({ erps }));
    } else {
      yield put(requestErrorErps({ msg: errorMessage || 'Erro ao carregar ERPs' }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(requestErrorErps({ msg: mensagem }));
  }
}

function* watchListarErpsInit() {
  yield takeEvery(LIST_ERPS_INIT as any, parseListarErps);
}

// --------------------------- Criar ERP ---------------------------------------------------------
const fetchCriarErp = async (nome: string, versoes: { versao: string }[]) => {
  try {
    const { status, dados, mensagem } = await criarErp({ nome, versoes });
    if (status && dados) {
      return { isError: false, erp: dados, errorMessage: null };
    }
    return { isError: true, erp: null, errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarErp({ payload }: any) {
  try {
    const { nome, versoes } = payload;
    const { isError, erp, errorMessage } = yield call(fetchCriarErp, nome, versoes ?? []);
    if (!isError) {
      yield put(createErpSuccess({ erp }));
    } else {
      yield put(requestErrorErps({ msg: errorMessage || 'Erro ao criar ERP' }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(requestErrorErps({ msg: mensagem }));
  }
}

function* watchCriarErpInit() {
  yield takeEvery(CREATE_ERP_INIT as any, parseCriarErp);
}

// --------------------------- Atualizar ERP ---------------------------------------------------------
const fetchAtualizarErp = async (id: string, nome: string, versoes: { versao: string }[]) => {
  try {
    const { status, dados, mensagem } = await atualizarErp(id, { nome, versoes });
    if (status && dados) {
      return { isError: false, erp: dados, errorMessage: null };
    }
    return { isError: true, erp: null, errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizarErp({ payload }: any) {
  try {
    const { id, nome, versoes } = payload;
    const { isError, erp, errorMessage } = yield call(fetchAtualizarErp, id, nome, versoes);
    if (!isError) {
      yield put(updateErpSuccess({ erp }));
    } else {
      yield put(requestErrorErps({ msg: errorMessage || 'Erro ao atualizar ERP' }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(requestErrorErps({ msg: mensagem }));
  }
}

function* watchAtualizarErpInit() {
  yield takeEvery(UPDATE_ERP_INIT as any, parseAtualizarErp);
}

// --------------------------- Remover ERP ---------------------------------------------------------
const fetchRemoverErp = async (id: string) => {
  try {
    const { status, mensagem } = await removerErp(id);
    if (status) {
      return { isError: false, errorMessage: null };
    }
    return { isError: true, errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseRemoverErp({ payload }: any) {
  try {
    const { id } = payload;
    const { isError, errorMessage } = yield call(fetchRemoverErp, id);
    if (!isError) {
      yield put(deleteErpSuccess({ id }));
    } else {
      yield put(requestErrorErps({ msg: errorMessage || 'Erro ao remover ERP' }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(requestErrorErps({ msg: mensagem }));
  }
}

function* watchRemoverErpInit() {
  yield takeEvery(DELETE_ERP_INIT as any, parseRemoverErp);
}

// --------------------------- Adicionar Versão a ERP ---------------------------------------------------------
const fetchAdicionarVersaoErp = async (id: string, versao: string) => {
  try {
    const { status, dados, mensagem } = await adicionarVersaoErp(id, versao);
    if (status && dados) {
      return { isError: false, erp: dados, errorMessage: null };
    }
    return { isError: true, erp: null, errorMessage: mensagem };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAdicionarVersaoErp({ payload }: any) {
  try {
    const { erpId, versaoNome } = payload;
    const { isError, erp, errorMessage } = yield call(fetchAdicionarVersaoErp, erpId, versaoNome);
    if (!isError) {
      yield put(addErpVersaoSuccess({ erp }));
    } else {
      yield put(requestErrorErps({ msg: errorMessage || 'Erro ao criar versão' }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(requestErrorErps({ msg: mensagem }));
  }
}

function* watchAdicionarVersaoErpInit() {
  yield takeEvery(ADD_ERP_VERSAO_INIT as any, parseAdicionarVersaoErp);
}

// WATCHS ------------------------------------------------
export default function* erpsSaga() {
  yield all([
    fork(watchListarErpsInit),
    fork(watchCriarErpInit),
    fork(watchAtualizarErpInit),
    fork(watchRemoverErpInit),
    fork(watchAdicionarVersaoErpInit)
  ]);
}
